import {
    PROJECT_DTO_TYPE,
    FILTER_DTO_TYPE,
    REPLACE_DTO_TYPE,
    SPLIT_DTO_TYPE,
    SUBSTRING_EXTRACT_DTO_TYPE,
    BLEND_DTO_TYPE,
    FORMULA_DTO_TYPE,
    AGGREGATION_DTO_TYPE,
    ANY_AGGREGATION_TYPE,
    AVG_AGGREGATION_TYPE,
    SUM_AGGREGATION_TYPE,
    COUNT_AGGREGATION_TYPE,
    COUNT_DISTINCT_AGGREGATION_TYPE,
    MAX_AGGREGATION_TYPE,
    MIN_AGGREGATION_TYPE,
    PIVOT_DTO_TYPE,
    AGGREGATION_TYPE,
    PIVOT_TYPE,
    MEDIAN_AGGREGATION_TYPE,
    APPROX_COUNT_DISTINCT_AGGREGATION_TYPE,
    MODE_AGGREGATION_TYPE,
    STDDEV_AGGREGATION_TYPE,
    SKEW_AGGREGATION_TYPE,
    STDDEV_POP_AGGREGATION_TYPE,
    KURTOSIS_AGGREGATION_TYPE,
    VAR_POP_AGGREGATION_TYPE,
    VAR_SAMP_AGGREGATION_TYPE
} from 'app/store/__generated__/types';

export enum OperationType {
    FILTER = FILTER_DTO_TYPE,
    REPLACE = REPLACE_DTO_TYPE,
    SPLIT = SPLIT_DTO_TYPE,
    SUBSTRING_EXTRACT = SUBSTRING_EXTRACT_DTO_TYPE,
    BLEND = BLEND_DTO_TYPE,
    PROJECT = PROJECT_DTO_TYPE,
    FORMULA = FORMULA_DTO_TYPE,
    AGGREGATE = AGGREGATION_DTO_TYPE,
    PIVOT = PIVOT_DTO_TYPE,
    UNION = 'UNION_DTO_TYPE',
    MODEL = 'MODEL'
}

export enum Operations {
    AGGREGATION = AGGREGATION_TYPE,
    PIVOT = PIVOT_TYPE
}

export const OperationGlossaryKey = {
    [FILTER_DTO_TYPE]: 'Filter',
    [REPLACE_DTO_TYPE]: 'Replace',
    [SPLIT_DTO_TYPE]: 'Split',
    [SUBSTRING_EXTRACT_DTO_TYPE]: 'SubstringExtract',
    [BLEND_DTO_TYPE]: 'Blend',
    [PROJECT_DTO_TYPE]: 'Project',
    [FORMULA_DTO_TYPE]: 'Formula',
    [AGGREGATION_DTO_TYPE]: 'Aggregation',
    [PIVOT_DTO_TYPE]: 'Pivot'
};

export enum AggregationType {
    SUM = SUM_AGGREGATION_TYPE,
    MODE = MODE_AGGREGATION_TYPE,
    AVG = AVG_AGGREGATION_TYPE,
    STDDEV = STDDEV_AGGREGATION_TYPE,
    STDDEV_POP = STDDEV_POP_AGGREGATION_TYPE,
    SKEW = SKEW_AGGREGATION_TYPE,
    KURTOSIS = KURTOSIS_AGGREGATION_TYPE,
    VAR_POP = VAR_POP_AGGREGATION_TYPE,
    VAR_SAMP = VAR_SAMP_AGGREGATION_TYPE,
    MIN = MIN_AGGREGATION_TYPE,
    MAX = MAX_AGGREGATION_TYPE,
    MEDIAN = MEDIAN_AGGREGATION_TYPE,
    COUNT_DISTINCT = COUNT_DISTINCT_AGGREGATION_TYPE,
    APPROX_COUNT_DISTINCT = APPROX_COUNT_DISTINCT_AGGREGATION_TYPE,
    COUNT = COUNT_AGGREGATION_TYPE,
    ANY = ANY_AGGREGATION_TYPE
}

export const AggregationGlossaryKey = {
    [ANY_AGGREGATION_TYPE]: 'Any',
    [AVG_AGGREGATION_TYPE]: 'Avg',
    [COUNT_AGGREGATION_TYPE]: 'Count',
    [COUNT_DISTINCT_AGGREGATION_TYPE]: 'CountDistinct',
    [APPROX_COUNT_DISTINCT_AGGREGATION_TYPE]: 'ApproxCountDistinct',
    [MAX_AGGREGATION_TYPE]: 'Max',
    [MEDIAN_AGGREGATION_TYPE]: 'Median',
    [MODE_AGGREGATION_TYPE]: 'Mode',
    [VAR_POP_AGGREGATION_TYPE]: 'VarPop',
    [VAR_SAMP_AGGREGATION_TYPE]: 'Var',
    [MIN_AGGREGATION_TYPE]: 'Min',
    [SUM_AGGREGATION_TYPE]: 'Sum',
    [STDDEV_AGGREGATION_TYPE]: 'StdDev',
    [STDDEV_POP_AGGREGATION_TYPE]: 'StdDevPop',
    [KURTOSIS_AGGREGATION_TYPE]: 'Kurtosis',
    [SKEW_AGGREGATION_TYPE]: 'Skew'
};
